import axios from './axios';
import { Individual } from '~/types';

export const getIndividual = (individualId: string) => {
  return axios.get<Individual>(`/individuals/${individualId}`);
};
